import React, { FC } from "react";
import {
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarExport,
} from "@mui/x-data-grid-pro";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((_theme) => ({
	customToolbar: {
		display: "flex",
		gap: "10px",
		border: "0px solid",
	},
	gap: {
		flexGrow: 100,
	},
}));

/** Props the DataGrid may pass to the toolbar slot; we strip ones that cause React DOM warnings. */
type GridToolbarSlotProps = React.ComponentProps<typeof GridToolbarContainer> & {
	onPointerEnterCapture?: unknown;
	onPointerLeaveCapture?: unknown;
	onResize?: unknown;
	onResizeCapture?: unknown;
};

const filterInvalidButtonProps = <P extends Record<string, unknown>>(props: P) => {
	const { onPointerEnterCapture, onPointerLeaveCapture, onResize, onResizeCapture, ...rest } = props;
	return rest;
};

const SafeColumnsButton = (props: Record<string, unknown>) => (
	<GridToolbarColumnsButton {...(filterInvalidButtonProps(props) as any)} />
);
const SafeFilterButton = (props: Record<string, unknown>) => (
	<GridToolbarFilterButton {...(filterInvalidButtonProps(props) as any)} />
);
const SafeExportButton = (props: Record<string, unknown>) => (
	<GridToolbarExport {...(filterInvalidButtonProps(props) as any)} />
);

export const AnnouncementsListGridToolbar: FC<GridToolbarSlotProps> = (props) => {
	const { classes } = useStyles();
	const containerProps = filterInvalidButtonProps(props as Record<string, unknown>);
	const filteredProps = filterInvalidButtonProps(props as Record<string, unknown>);

	return (
		<GridToolbarContainer className={classes.customToolbar} {...containerProps}>
			<SafeColumnsButton {...filteredProps} />
			<SafeFilterButton {...filteredProps} />
			<SafeExportButton {...filteredProps} />
			<Box className={classes.gap} />
		</GridToolbarContainer>
	);
};
